// TODO: Replace with NodeEnvironmentAdapter usage
export const API_BASE_URL: string = process.env.REACT_APP_API_BASE_URL || '';

// TODO: Replace with NodeEnvironmentAdapter usage
export const DISABLE_FLOW_DEEP_LINKING_PROTECTION: boolean =
  process.env.REACT_APP_DISABLE_FLOW_DEEP_LINKING_PROTECTION === 'true';
